:host {
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

svg {
    display: block;
    stroke-width: 1.5px;
    stroke-linecap: round;
    stroke-linejoin: round;

    animation-name: spinClockwise;
    animation-iteration-count: 0;
    animation-timing-function: linear;
    animation-duration: 500ms;
}

svg:not([stroke]):not([fill]) {
        fill: currentColor;
    }

svg.antiClockwise {
        animation-name: spinAntiClockwise;
    }

svg.spin {
        animation-iteration-count: infinite;
    }

@keyframes spinClockwise {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

@keyframes spinAntiClockwise {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(-360deg);
    }
}
